'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError(title, error, definedAt) {
  this.Ys = null;
  this.Yr = null;
  this.aYh = null;
  this.Ys = title;
  this.Yr = error;
  this.aYh = definedAt;
}
export { $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError as $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError };
$p = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError() {
}
export { $h_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError as $h_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError };
$h_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError)) {
    if ((this.Ys === x$0.Ys)) {
      var x = this.Yr;
      var x$2 = x$0.Yr;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "InternalError";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Ys;
  }
  if ((n === 1)) {
    return this.Yr;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "title";
  }
  if ((n === 1)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.VM = (function() {
  return this.aYh;
});
function $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kz)));
}
export { $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError as $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError };
var $d_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError, "app.webclient_prelude.components.AppMainModal$InternalError", ({
  kz: 1,
  d9: 1,
  cU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError as $d_Lapp_webclient\uff3fprelude_components_AppMainModal$InternalError };
//# sourceMappingURL=app.webclient_prelude.components.-App-Main-Modal$-Internal-Error.js.map
